import React, { useEffect, useState } from "react";

import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate, useParams } from "react-router-dom";

import TextField from "common/TextField";
import { CommonButton } from "components/common/button/Button";
import Loader from "components/common/loader/Loader";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import { updateUserProfile } from "services/UserManagementServices";

import "./userProfile.scss";
import { updateProfilePicture } from "services/UserAccountManagementServices";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getUserIdFromStorage } from "common/utils/utilities";
import { useTranslation } from "react-i18next";
const UserProfile = ({
  isFetching,
  profileData,
  handleRefresh,
  profileImage,
  setUserProfilePicture,
}) => {
  const { t } = useTranslation();
  const { firstName, lastName, email, role, phoneNumber } = profileData;

  const userId = getUserIdFromStorage();

  const [loading, setLoading] = useState(false);
  const [profileImageUpdate, setProfileImageUpdate] = useState(false);
  const [profileImageFile, setProfileImageFile] = useState(null);
  const validate = Yup.object({
    firstName: Yup.string().required(t("required")).max(20, t("max-name-char-limit")),
    lastName: Yup.string().required(t("required")).max(20, t("max-name-char-limit")),
    email: Yup.string()
      .required(t("required"))
      .email(t("email-error")),
    role: Yup.string(),
    phoneNumber: Yup.number().required(t("required")).min(99999999, t("min-phone-no-length")),
  });
  const initialValues = {
    firstName,
    lastName,
    email,
    phoneNumber,
    role: role?.roleTranslatedValue,
  };
  const handleImageChange = async () => {
    if (profileImageFile) {
      let form_data = new FormData();

      const payLoad = {
        userId,
        profilePicture: profileImageFile,
      };
      Object.keys(payLoad).forEach((key) => form_data.append(`${key}`, payLoad[key]));
      let response = await updateProfilePicture(form_data);
      if (!response.success) {
        toast.error(t("err-put-profile"));
      }
    }
    handleRefresh();
    setLoading(false);
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    const payLoad = {
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
    };
    const result = await updateUserProfile(payLoad);
    if (result.success) {
      handleImageChange();
    }
  };
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileName = file?.name;
      const extension = fileName?.split(".")?.pop()?.toLowerCase();
      const isSupported = ["jpg", "png", "jpeg"].includes(extension);
      if (isSupported) {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          setProfileImageFile(event.target.files[0]);
          setUserProfilePicture(reader.result);
          setProfileImageUpdate(true);
        };
      } else {
        toast.error(t("err-img-format"));
      }
    }
  };
  return (
    <>
      <Toaster />
      <div>
        {isFetching ? (
          <Loader />
        ) : (
          <Row className="profile-details">
            <Col md={4}>
              <div className="w-100 h-100 d-flex justify-content-center pt-3">
                <div className="circle-icon">
                  <img
                    alt="not found"
                    src={profileImage ? profileImage : "/assets/image/profile.png"}
                  />
                  <div className="overlay">
                    <FontAwesomeIcon icon={faCamera} size="2x" color="white" />
                    <input type="file" accept="image/png, image/jpeg" onChange={onImageChange} />
                  </div>
                </div>
              </div>
            </Col>
            <Col md={4}>
              <Formik
                initialValues={initialValues}
                validationSchema={validate}
                onSubmit={(values) => {
                  handleSubmit(values);
                }}>
                {(formik) => {
                  return (
                    <>
                      <Form>
                        <p className="info">{t("first-name")}</p>
                        <TextField
                          type="text"
                          placeholder={t("first-name")}
                          name="firstName"
                          onChange={formik.handleChange}
                          value={formik.values.firstName}
                          error={formik.touched.firstName && formik.errors.firstName}
                        />
                        <p className="info">{t("last-name")}</p>
                        <TextField
                          type="text"
                          placeholder={t("last-name")}
                          name="lastName"
                          onChange={formik.handleChange}
                          value={formik.values.lastName}
                          error={formik.touched.lastName && formik.errors.lastName}
                        />
                        <p className="info">{t("role")}</p>
                        <TextField
                          isDisabled={true}
                          type="text"
                          placeholder={t("role")}
                          name="role"
                          onChange={formik.handleChange}
                          value={formik.values.role}
                          error={formik.touched.role && formik.errors.role}
                        />
                        <p className="info">{t("email")}</p>
                        <TextField
                          isDisabled={true}
                          type="text"
                          placeholder={t("email")}
                          name="email"
                          onChange={formik.handleChange}
                          value={formik.values.email}
                          error={formik.touched.email && formik.errors.email}
                        />
                        <p className="info">{t("phone-no")}</p>

                        <PhoneInput
                          country={"de"}
                          value={formik.values.phoneNumber}
                          onChange={(phone) => {
                            formik.setFieldValue("phoneNumber", phone);
                          }}
                          placeholder={t("phone-no")}
                          containerClass="phoneNumberContainer"
                          inputClass="phoneNumberInput"
                        />

                        <div
                          className="d-flex justify-content-end"
                          style={{
                            padding: "0 0.4rem",
                          }}>
                          <button
                            className={`${
                              (formik.values.firstName !== firstName ||
                                formik.values.lastName !== lastName ||
                                formik.values.phoneNumber !== phoneNumber ||
                                profileImageUpdate) &&
                              !formik.errors.firstName &&
                              !formik.errors.lastName &&
                              !formik.errors.phoneNumber &&
                              !loading
                                ? ""
                                : "opacity-50"
                            } update-btn mb-5 mt-3 w-auto`}
                            disabled={
                              (formik.values.firstName !== firstName ||
                                formik.values.lastName !== lastName ||
                                formik.values.phoneNumber !== phoneNumber ||
                                profileImageUpdate) &&
                              !formik.errors.firstName &&
                              !formik.errors.lastName &&
                              !formik.errors.phoneNumber &&
                              !loading
                                ? false
                                : true
                            }
                            type="submit">
                            {loading ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                                {t("update-profile")}
                              </>
                            ) : (
                              t("update-profile")
                            )}
                          </button>
                        </div>
                      </Form>
                    </>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default UserProfile;
